// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { getIsProdEnvironment } from '@/utils/environmentUtils';

let isInitialized = false;
let isIdentified = false;

export const initSentry = () => {
  if (!getIsProdEnvironment() || isInitialized) {
    return;
  }

  try {
    Sentry.init({
      dsn: 'https://85c109bfc1f5326001633fa0d504ea3c@o456280.ingest.us.sentry.io/4507441445928960',
      // Adjust this value in production, or use tracesSampler for greater control
      tracesSampleRate: 1,

      // Setting this option to true will print useful information to the console while you're setting up Sentry.
      debug: false,

      replaysOnErrorSampleRate: 1.0,
      environment: 'production',
      release: process.env.NEXT_SENTRY_RELEASE,
      // This sets the sample rate to be 10%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: 1.0,

      // You can remove this option if you're not planning to use the Sentry Session Replay feature:
      integrations: [
        Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
      ],
    });
  } catch (error) {
    console.error('Failed to init sentry', error);
  }

  isInitialized = true;
};

export const identifySentry = (email, appKey) => {
  if (!getIsProdEnvironment() || isIdentified) {
    return;
  }

  try {
    Sentry.setUser({ email });
    Sentry.setContext('account', {
      appKey,
    });
  } catch (error) {
    console.error('Failed to identify sentry', error);
  }

  isIdentified = true;
};

export default initSentry;
